import React, { Component } from 'react';
import './select.scss';

export class Select extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.props.onChange(event);
    }

    render() {
        const {value, name, className, disabled, children, label} = this.props;

        return (
            <select name={name} className={`selectInput ${className ? className : ''} ${label ? 'label' : ''}`} value={value} onChange={this.handleChange} disabled={disabled}>
                {children}
            </select>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Form/Select.jsx